import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance, { axiosFormInstance } from "../../api/axiosInstance";
import { endpoints } from "../../api/endpoints";

export const fetchContractDetails = createAsyncThunk(
  "contracts/fetchContractDetails",
  async (userData, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        endpoints.contractdetails,
        userData
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
export const createContract = createAsyncThunk(
  "contracts/createContract",
  async (userData, thunkAPI) => {
    try {
      const response = await axiosFormInstance.post(
        endpoints.createcontract,
        userData
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

const contractSlice = createSlice({
  name: "contracts",
  initialState: {
    contractDetails: null,
    signature: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchContractDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchContractDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.contractDetails = action.payload;
      })
      .addCase(fetchContractDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createContract.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createContract.fulfilled, (state, action) => {
        state.loading = false;
        state.signature = action.payload;
      })
      .addCase(createContract.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default contractSlice.reducer;
